import React, { createContext, useEffect, useState } from 'react';
import { CurrentPage } from './models';

type AdType = "home" | "search" | "details" | "myAds"

export const Context = createContext(null);

interface GaContextProps{
    // adType:AdType
}

export const GaContext: React.FC<GaContextProps> = props => {
    const GaContextPage = useState("");

    return (
        <Context.Provider value={GaContextPage}>
            {props.children}
        </Context.Provider>

    )
}
  



// WEBPACK FOOTER //
// ./src/GAContext.tsx